import { render, staticRenderFns } from "./Snake.vue?vue&type=template&id=3c5a3c12"
import script from "./Snake.vue?vue&type=script&lang=js"
export * from "./Snake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports